import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox'];

  selectAll() {
    // eslint-disable-next-line no-param-reassign,no-return-assign
    this.checkboxTargets.forEach((input) => (input.checked = true));
  }

  deselectAll() {
    // eslint-disable-next-line no-param-reassign,no-return-assign
    this.checkboxTargets.forEach((input) => (input.checked = false));
  }
}
